import { render, staticRenderFns } from "./inv_trans_logistics_record.vue?vue&type=template&id=17b518ae"
import script from "./inv_trans_logistics_record.vue?vue&type=script&lang=js"
export * from "./inv_trans_logistics_record.vue?vue&type=script&lang=js"
import style0 from "./inv_trans_logistics_record.vue?vue&type=style&index=0&id=17b518ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports